import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  height: 2px;
  overflow: hidden;
  width: 100px;
`;

const Progress = styled.div`
  background-color: #fff;
  height: 100%;
  transition: width 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Value = styled.div`
  color: #fff;
  opacity: 1;
`;

const ProgressBar = ({value, max}: {value: number; max: number}) => {
  const percent = (value / max) * 100 || 0;

  return (
    <ProgressBarContainer>
      <Progress style={{width: `${percent}%`}}>
        <Value>{value}</Value>
      </Progress>
    </ProgressBarContainer>
  );
};

export default ProgressBar;
